export const formatJsonValue = (value) => {
  if (value == null || value === "") {
    return "-";
  }

  if (typeof value === "string") {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      return value;
    }
  }

  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
};

export const getOrderReference = (order) =>
  order?.merit_order_id ??
  order?.reference_number ??
  order?.reference ??
  order?.external_id ??
  "-";

export const getOrderAmount = (order) =>
  order?.amount ?? order?.total_amount ?? order?.price ?? "-";

export const getCustomerName = (order) =>
  order?.customer_name ?? order?.customer?.name ?? "-";

export const getCustomerEmail = (order) =>
  order?.customer_email ?? order?.customer?.email ?? "-";

export const getGiftCardName = (order) =>
  order?.gift_card_name ??
  order?.product_name ??
  order?.gift_card?.name ??
  "-";

export const getOrderLogs = (order) =>
  order?.api_logs ?? order?.logs ?? order?.merit_api_logs ?? [];

export const getLogEndpoint = (log) =>
  log?.endpoint ?? log?.path ?? log?.url ?? "-";

export const getLogMethod = (log) =>
  log?.http_method ?? log?.method ?? "-";

export const getLogStatusCode = (log) =>
  log?.status_code ?? log?.response_status ?? log?.http_status ?? "-";

export const isLogFailed = (log) => {
  if (typeof log?.failed === "boolean") {
    return log.failed;
  }

  if (typeof log?.is_success === "boolean") {
    return !log.is_success;
  }

  if (typeof log?.success === "boolean") {
    return !log.success;
  }

  const statusCode = Number(getLogStatusCode(log));
  if (!Number.isNaN(statusCode) && statusCode >= 400) {
    return true;
  }

  return Boolean(log?.error_message ?? log?.error);
};

export const getLogOrderReference = (log) =>
  log?.merit_order_id ?? log?.order_id ?? log?.merit_order?.id ?? "-";

export const buildMeritListParams = (filterObj = {}) => {
  const { keyword, ...rest } = filterObj;

  return {
    page_size: 10,
    page_number: 1,
    ...rest,
    search: rest.search ?? keyword ?? "",
  };
};

export const buildMeritApiLogsParams = (filterObj = {}) => {
  const params = {
    page_size: 10,
    page_number: 1,
    ...filterObj,
  };

  if (!params.failed_only) {
    delete params.failed_only;
  }

  return params;
};
